export interface IProcessable<InputType> {

	process(input: InputType);
}
